<template>
<div v-if="Access('CustomersAdd')" :id="'CookiesDialog_' + DialogIndex" class="CookiesDialogdBody">
  <DialogDisabler v-if="Saving"></DialogDisabler>
  <div class="M-Auto DialogContainer">
    <div class="DialogBody">
      <div class=" D-Flex W-100" style="text-align:left; margin-bottom:15px; white-space: nowrap;">
      </div>
      <!-- Customer -------------------------------------- -->
      <div class="CookiesRow">
        <div class="CookiesRow W-100 D-Flex">
          <label class="UserImage M-Auto" :style="'background-image: url(' + DefaultImageHandler(SelectedUserImage, $store.state.CookiesConfig.UserImage) + ');'">
            <input @change="UserImageChanged()" name="UserImage" type="file" accept="image/*">
          </label>
        </div>
        <input v-model="Company" :class=" (ErrorsVisibilty & !Company) && 'ErrorBorder' " class="CookiesInput color2" type="Text" name="Company" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'الشركة': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'Company': ''" autocomplete="off">
        <input v-model="Name" :class=" (ErrorsVisibilty & !Name) && 'ErrorBorder' " class="CookiesInput color2" type="Text" name="Phone" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'الاسم': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'Name': ''" autocomplete="off">
        <input v-model="PhoneNumber" :class=" (ErrorsVisibilty & !PhoneValidator(PhoneNumber)) && 'ErrorBorder'" class="CookiesInput color2" type="Text" name="Phone" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'الهاتف': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'Phone': ''" autocomplete="off">
        <CookiesDropDown :Radio="true" :Res="'NewEmpGender'" :Width="'7em'" :Selector="LanguageSelector('EN', 'AR')" :Options="Genders" :Type="'Object'" :Name="''"></CookiesDropDown>
        <div class="CookiesRowSplitter"/>
        <div class="CookiesRowSpacer"/>
        <div class="W-100">
          <span>{{LanguageSelector('Sign In Info', 'معلومات تسجيل الدخول')}}</span>
        </div>
        <div class="CookiesRowSpacer"/>
        <div class="W-100" style="direction: ltr;">
        <input v-model="Email" :class=" (ErrorsVisibilty & Email === '') && 'ErrorBorder'" class="CookiesInput color2 W-50" type="Text" name="Phone" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'البريد الالكتروني': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'Email': ''" autocomplete="off">
        <span>@ordari.com</span>
        </div>
        <form class="W-100">
          <input v-model="NewPassWord" :type="Unhider" :class="PassValidaton.NewPass && 'ErrorBorder'" class="CookiesInput color2" name="New Password" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'كلمة السر': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'New Password': ''" autocomplete="off">
          <input v-model="NewPassWordCheck" :type="Unhider" :class="PassValidaton.ConfirmPass && 'ErrorBorder'" class="CookiesInput color2" name="Confirm New Password" :placeholder="$store.state.CookiesConfig.Language === 'ARA' ? 'تأكيد كلمة السر': '' + $store.state.CookiesConfig.Language === 'ENG' ? 'Confirm New Password': ''" autocomplete="off">
        </form>
      </div>
      <div class="W-100" style="padding:5px">
        <CookiesCheckBox style="text-align:left;" :Name="LanguageSelector('Show passwords', 'كشف كلمة المرور')" :Res="'NewEmp_NewPasswordUnHide'" :Type="'Switch'"></CookiesCheckBox>
      </div>
    </div>
  </div>
</div>
<div v-if="Access('CustomersAdd')" class="CookiesDialogFooter">
  <div class=" F-Bold" style="margin: auto 1em;">
    <button @click="$router.go(-1)" style="background: var(--colorr1);" class="F-Bold CookiesButton DialogFooterButton">{{$store.state.CookiesConfig.Language === 'ARA' ? 'الغاء': ''}}{{$store.state.CookiesConfig.Language === 'ENG' ? 'Cancel': ''}}</button>
    <button @click="SaveCustomer()" :style="'background: ' + $store.getters.Theme.UserColors.main" class="F-Bold CookiesButton DialogFooterButton">{{$store.state.CookiesConfig.Language === 'ARA' ? 'حفظ': ''}}{{$store.state.CookiesConfig.Language === 'ENG' ? 'Save': ''}}</button>
  </div>
</div>

</template>

<script>
export default {
  setup () {},
  components: {},
  beforeCreate () {
    this.$store.state.CookiesMemory.NewEmpGender = {}
  },
  created () {},
  data () {
    return {
      BarCodeFrom: 1,
      BarCodeTo: 2,
      Name: '',
      Company: '',
      PhoneNumber: '',
      Email: '',
      Gender: '',
      Type: '',
      Salary: '',
      Status: '',
      Identity: {},
      ErrorsVisibilty: false,
      NewPassWord: '',
      NewPassWordCheck: '',
      selectedFile: '',
      SelectedUserImage: '',
      UserImage: '',
      Genders: [
        {
          EN: 'Male',
          AR: 'ذكر'
        },
        {
          EN: 'Female',
          AR: 'انثى'
        },
        {
          EN: 'Company',
          AR: 'شركة'
        }
      ],
      Saving: false
    }
  },
  props: {
    DialogIndex: Number,
    DialogData: { default: '' }
  },
  methods: {
    SaveCustomer () {
      console.log(this.NewCustomerData)
      if (this.DialogError.length > 0) {
        this.ErrorsVisibilty = true
        return
      }
      this.Saving = true
      if (!this.selectedFile || this.selectedFile === null || this.selectedFile === undefined) {
        this.Post('POST', 'Customer', this.NewCustomerData).then(response => {
          this.Saving = false
          this.CloseDialog(this.DialogIndex)
        }, error => {
          this.Saving = false
          error.CookiesError = 'Error in Adding New Customer'
          this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
        })
      } else {
        this.PostImage(this.selectedFile).then(response => {
          this.UserImage = response.url
          this.Post('POST', 'Customer', this.NewCustomerData).then(response => {
            this.Saving = false
            this.CloseDialog(this.DialogIndex)
          }, error => {
            this.Saving = false
            error.CookiesError = 'Error in Adding New Customer'
            this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
          })
        }, error => {
          this.Saving = false
          error.CookiesError = 'Error in Uploading Image'
          this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
        })
      }
    },
    ChangePassword () {
      this.OpenDialog('ChangePassDialog', 'Change Password', this.DialogData) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    UserImageChanged () {
      var file = event.target.files[0]
      this.selectedFile = file
      if (!file) {
        this.SelectedUserImage = ''
        return
      }
      this.SelectedUserImage = URL.createObjectURL(file)
    }
  },
  mounted () {
    if (!this.Access('CustomersAdd')) {
      return
    }
    try {
      var DialogPos = document.getElementById('CookiesDialog_' + this.DialogIndex).offsetTop - 60
      window.scrollTo(0, DialogPos)
    } catch (error) {
      console.log('error: ', error.message)
    }
  },
  computed: {
    NewCustomerData () {
      return {
        BarCodeFrom: 1,
        BarCodeTo: 2,
        Company: this.Company,
        Name: this.Name,
        PhoneNumber: this.PhoneNumber,
        Email: this.Email + '@ordari.com',
        Gender: this.$store.state.CookiesMemory.NewEmpGender.EN,
        PasswordHash: this.NewPassWord,
        Active: true,
        ImgUrl: this.UserImage
      }
    },
    DialogError () {
      var DialogErrors = []
      this.PassValidaton.ErrorsList.length > 0 && DialogErrors.push('Please Enter Customer\'s pass')
      this.Name === '' && DialogErrors.push('Please Enter Customer\'s Name')
      this.Company === '' && DialogErrors.push('Please Enter Company\'s Name')
      !this.PhoneValidator(this.PhoneNumber) && DialogErrors.push('Please Enter Customer\'s Name')
      this.Email === '' && DialogErrors.push('Please Enter Customer\'s Email')
      return DialogErrors
    },
    isActive () {
      return this.$store.state.CookiesMemory.D_NewCustomer_Active
    },
    PassValidaton () {
      var DialogErrors = {
        NewPass: false,
        ConfirmPass: false,
        ErrorsList: []
      }
      if (this.NewPassWord === '') {
        DialogErrors.ErrorsList.push('Please enter a new passord')
        if (this.ErrorsVisibilty) {
          DialogErrors.NewPass = true
        }
      }
      if (this.NewPassWord.length < 5) {
        DialogErrors.ErrorsList.push('Password must be at least 5 characters')
        if (this.ErrorsVisibilty) {
          DialogErrors.NewPass = true
        }
      }
      if (this.NewPassWordCheck !== this.NewPassWord && this.NewPassWordCheck !== '') {
        DialogErrors.ErrorsList.push('Passwords didn\'t match')
        if (this.ErrorsVisibilty) {
          DialogErrors.ConfirmPass = true
        }
      }
      return DialogErrors
    },
    Unhider () {
      return this.$store.state.CookiesMemory.NewEmp_NewPasswordUnHide ? 'text' : 'password'
    }
  }
}
</script>

<style scoped>
.DialogBody{
  width: 800px;
  max-width: 65vw;
}
.DialogContainer{
  padding: 50px;
}
@media (max-width: 500px) {
  .FlexBreaker{
    flex-direction: column;
  }
  .FlexBreaker > *{
    width: 80% !important;
  }
  .DialogContainer{
    padding: 1em;
  }
  .CookiesDialogdBody{
    font-size: 3vw;
  }
}
@media (max-width: 300px) {
  .CookiesDialogdBody{
    font-size: 4vw;
  }
}
.CookiesInputHolder{
  height: 30px;
  width: 200px;
  border: none;
  border-radius: var(--rad2);
  flex: auto;
  padding: 10px 25px;
  outline: none;
  font-size: 17px;
  margin: 6px;
  position: relative;
}

.CookiesInputInside::placeholder{
  opacity: 0.35;
}
.CookiesRowSpacer{
  width: 100%;
  height: 20px;
}

.CookiesNumberInput{
  display: flex;
  margin: auto;
  border-radius: var(--rad3);
  overflow: hidden;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.ErrorBorder{
  border: solid var(--colorr2) 2px;
  padding: 8px 23px;
}

.barcode{
  display: flex;
  justify-content: center;
  width:300px;
  max-width:100%;
  height:100px;
  background: var(--white);
  border: solid 1px rgb(167, 167, 167);
  border-radius: var(--rad3);
  overflow: hidden;
  filter: drop-shadow(var(--shadow1));
}
.UserImage{
  width: 10em;
  height: 10em;
  margin-bottom: 1.5em;
  background-color: var(--shade2);
  border-radius: 5em;
  cursor: pointer;
  box-shadow: inset var(--shadow1);
  background-size: cover;
  background-position: center;
}
.UserImage > input{
  width: 0;
  height: 0;
  pointer-events: none;
}
</style>
